import React from 'react';
import { Section } from './ui/Section';
export function WhyExists() {
  return <Section data-id="element-232" data-mp="1v7aia750x6ee">
      <div className="max-w-2xl mx-auto text-center" data-id="element-233" data-mp="1v7u1dr6eu0u0">
        <h2 className="font-display text-2xl md:text-4xl font-bold text-brand-title mb-6 leading-tight" data-id="element-234" data-mp="1v728io476h7f">
          ¿Por qué existe el Sistema Mimetismo Nutricional™?
        </h2>

        <div className="text-left space-y-4 bg-white border border-brand-border rounded-2xl p-6 md:p-8 shadow-card" data-id="element-235" data-mp="240xefyd58bo4">
          <p className="font-body text-brand-text leading-relaxed text-sm md:text-base" data-id="element-236" data-mp="1gabcmotqfnmk">
            Porque intentar comer sin gluten en España es nadar contra
            corriente. El bocadillo del desayuno, el pan con tomate, la pasta
            del domingo, la pizza del viernes... Todo gira alrededor del
            trigo.
          </p>
          <p className="font-body text-brand-text leading-relaxed text-sm md:text-base" data-id="element-237" data-mp="31muza2ezwt38">
            Y cuando buscas alternativas, encuentras dos caminos igual de
            frustrantes: resignarte a comer "la versión triste" de todo, o
            gastar una fortuna en productos industriales que te siguen
            inflamando y no se parecen en nada a lo que recuerdas.
          </p>
          <p className="font-body text-brand-text leading-relaxed text-sm md:text-base" data-id="element-238" data-mp="39jgnf3jhkefz">
            Creamos este sistema porque la pregunta correcta no es{' '}
            <span className="italic" data-id="element-239" data-mp="3ehieobr2fk2j">"¿qué puedo comer?"</span>. Es{' '}
            <span className="text-brand-primary font-semibold" data-id="element-240" data-mp="2gvujfu6cj7sl">
              "¿cómo reconstruyo lo que me gusta con ingredientes que no me
              inflamen?"
            </span>
            . Esa diferencia lo cambia todo.
          </p>
        </div>
      </div>
    </Section>;
}